import { createSlice } from '@reduxjs/toolkit';
import { StateAdvertFavorite } from '#advertFavorite/types';
import { REDUCER_ADVERT_FAVORITE_NAME } from '#advertFavorite/constants';

const initialState: StateAdvertFavorite = {
  isOpen: false,
};

const sliceAdvertFavorite = createSlice({
  name: REDUCER_ADVERT_FAVORITE_NAME,
  initialState,
  reducers: {
    open: (state) => {
      state.isOpen = true;
    },
    hide: (state) => {
      state.isOpen = false;
    },
  },
});

const reducerAdvertFavorite = sliceAdvertFavorite.reducer;

const {
  open: favoriteOpen,
  hide: favoriteHide,
} = sliceAdvertFavorite.actions;

export {
  reducerAdvertFavorite,
  favoriteOpen,
  favoriteHide,
};
